module.exports = __webpack_public_path__ + "img/shoppingMall.d951adc9.png";